import React from 'react';
import useMediaManifest from '../utils/useMediaManifest';
import { RoleCTASection, RoleFeatureGridSection, RoleStepsSection } from '../components/RoleSections';
import { IconBolt, IconMenu, IconPhone, IconQr, IconSpark, IconShield } from '../components/icons';
import './Page.css';

export default function CustomerPage() {
  const media = useMediaManifest('customer');
  const hero = media[0];

  const features = [
    { icon: <IconQr />, title: 'Scan & start', text: 'Open the menu instantly by scanning the QR code on the table.' },
    { icon: <IconMenu />, title: 'Easy browsing', text: 'Clear categories, images, and prices — no confusing PDFs.' },
    { icon: <IconPhone />, title: 'Made for mobile', text: 'Smooth scrolling, big touch targets, and fast loading.' },
    { icon: <IconBolt />, title: 'Always updated', text: 'See real prices and availability — no outdated printed menus.' },
    { icon: <IconSpark />, title: 'Find favorites', text: 'Discover new dishes faster with a visual-first layout.' },
    { icon: <IconShield />, title: 'Trusted experience', text: 'Clean, consistent design across restaurants.' }
  ];

  const steps = [
    { title: 'Scan the QR', text: 'Use your phone camera to open the menu in seconds.' },
    { title: 'Browse & decide', text: 'Explore categories, photos, and details without endless scrolling.' },
    { title: 'Enjoy the experience', text: 'Less waiting, more clarity — the menu feels modern and premium.' }
  ];

  return (
    <div className="page">
      <div className="container">
        <div className="pageHero">
          {hero?.type === 'video' ? (
            <video className="pageHeroMedia" src={hero.src} autoPlay muted loop playsInline />
          ) : hero ? (
            <img className="pageHeroMedia" src={hero.src} alt={hero.alt || 'Hero'} />
          ) : null}

          <div className="pageHeroContent">
            <div className="pageTopBar">
              <button className="btn btnGhost backBtn" type="button" onClick={() => (window.location.hash = '#/home')}>
                Back
              </button>

              <div className="pageTopActions">
                <a className="btn btnGhost" href="#/owner">
                  View owner page
                </a>
              </div>
            </div>

            <div>
              <div className="pageTitle">Customer</div>
              <div className="pageSubtitle">Scan, browse beautifully, and pick faster — right from your phone.</div>
            </div>

            <div className="pageChips">
              <div className="chip">QR-first</div>
              <div className="chip">Visual menu</div>
              <div className="chip">Mobile-perfect</div>
            </div>

            <div className="pageHeroCtas">
              <a className="btn btnPrimary" href="#customer-features">
                Explore features
              </a>
            </div>
          </div>
        </div>
      </div>

      <RoleFeatureGridSection
        id="customer-features"
        eyebrow="For customers"
        title="A better way to browse menus"
        lead="Less friction at the table — more visuals, clearer choices, and a premium feel."
        items={features}
      />

      <RoleStepsSection
        id="customer-how"
        eyebrow="Experience"
        title="From scan to order — in moments"
        lead="Designed for one-hand use and fast decisions." 
        steps={steps}
      />

      <RoleCTASection
        id="customer-cta"
        title="Want this experience at your favorite restaurant?"
        lead="Share Menu Bazaar with the restaurant owner and help bring a modern menu to your table."
        bullets={["Fast QR menu", "Always up-to-date items", "Premium mobile UI"]}
        primary={{ href: '#/home#choose', label: 'Choose a role' }}
        secondary={{ href: '#/home', label: 'Back to landing' }}
      />
    </div>
  );
}
